// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2251bef8","130":"68f1028a","191":"0265c012","542":"93915229","672":"3a4a3b43","743":"4a451c24","885":"04d03193"}[chunkId] + ".chunk.js";
};